import React, { Fragment } from 'react';
import moment from 'moment-mini';

import PageAndTemplateStatusUI from './page_and_template_status_ui.jsx';
import routesByPageStore from 'zoomforth_zf/appglobals/routes-by-page.js';
import withBackboneListeners from 'zoomforth_zfutils/with_backbone_listeners.jsx';
import { RedirectIcon, ArchiveIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import {
  getPageStatus
} from 'zoomforth_shared_management/lib/page_status.js';

import { 
  getDraftPageVersionViewerURL 
} from 'zoomforth_page_version_viewer/utils.js';

import {
  STATUS_ARCHIVED,
  STATUS_REDIRECTED,
  STATUS_ACTIVE
} from 'site_status.js';

import { defaultDatetimeFormat } from 'zoomforth_zfutils/datetime_formatting.js';

const PageStatus = ({ page, showSecondaryDescription, ...props }) => {
  let isActive = false;
  var secondaryDescription = '';
  var icon = <span>&bull;</span>;
  
  const { 
    status, 
    description 
  } = getPageStatus({ page, pageLinks:routesByPageStore.get(page.id) });

  switch (status) {

  case STATUS_ARCHIVED:
    icon = <ArchiveIcon className="archived-icon" />;
    break;

  case STATUS_REDIRECTED:
    icon = <RedirectIcon className="redirected-icon" />;
    break;

  case STATUS_ACTIVE:
    isActive = true;
    break;
  }

  let extraTooltip = '';
  
  if(isActive){
    if (page.hasUnpublishedChanges()) {
      if (page.isPendingApproval()) {
        secondaryDescription += ' Needs approval';
        extraTooltip = ` There have been changes made to this site which need to be approved by an administrator 
          before they will be visible.`;
      } else {
        secondaryDescription =  <a className="unpub-link" href={getDraftPageVersionViewerURL(page.get('urlId'))} target="_blank">
          {secondaryDescription} Unpublished changes
        </a>;
        extraTooltip = ` There have been changes made to this site, but they won't be visible until they are 
          published. Open the site in the editor to publish the changes.`;
      }
    }
  }

  let scheduledDeactivationMessage = '';
  let deactivationTooltip = '';

  if(page.getDeactivationSchedule() && !page.isDeactivated()){
    const deactivationDate = defaultDatetimeFormat(moment(page.getDeactivationSchedule()), { includeTime: true });
    scheduledDeactivationMessage = ` until ${deactivationDate}`;
    deactivationTooltip = ` This site is scheduled for deactivation and will remain in its current state until ${deactivationDate}.`;
  }

  let scheduledRedirectMessage = '';
  let redirectTooltip = '';

  if(page.isRedirectScheduled() && !page.isRedirected()){
    const redirectionDate = defaultDatetimeFormat(moment(page.get('redirect_scheduled_at')), { includeTime: true });
    scheduledDeactivationMessage = ` until ${redirectionDate}`;
    deactivationTooltip = ` This site is scheduled for redirection and will remain in its current state until ${redirectionDate}.`;
  }

  const tooltip = (
    <Fragment>
      <p>{description + extraTooltip}</p>

      {
        deactivationTooltip ?
          <p>{ deactivationTooltip }</p>
        : redirectTooltip ?
          <p>{ redirectTooltip }</p>
        :
          null
      }
    </Fragment>
  );

  const enhancedDescription = (
    scheduledDeactivationMessage ?
      status + scheduledDeactivationMessage
    : scheduledRedirectMessage ?
      status + scheduledRedirectMessage
    :
      status
  );

  return (
    <PageAndTemplateStatusUI
      {...{
        description: enhancedDescription,
        icon,
        isActive,
        secondaryDescription: showSecondaryDescription && secondaryDescription,
        tooltip: tooltip,
        ...props
      }}
    />
  );
};

PageStatus.defaultProps = {
  showSecondaryDescription: true
};

export default withBackboneListeners(PageStatus, { page:'change' });
